import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const fetchgetPreOnboardingDocsById = createAsyncThunk(
  "getPreOnboardingDocsById/fetchgetPreOnboardingDocsById",
  async ({ type, id }, { rejectWithValue }) => {
    try {
      const url = `${api.getPreOnboardingDocsById}?type=${type}&id=${id}`;
      const response = await axiosPrivate.get(url, {
        headers: {
          "custom-auth-type": "token",
        },
        responseType: "blob",
      });
      if (response.data.size === 0) return { type, url: null };
      if (response.data) {
        if (response.data === null) return null;
        const imageBlob = response.data;
        const imageUrl = URL.createObjectURL(imageBlob);
        return { type, url: imageUrl };
      } else {
        toast.error(`${response.data.reason}`, {
          className: "toast-error-custom",
        });
        localStorage.removeItem("token");
        localStorage.clear();
        globalThis.location.replace("/email-verification", { replace: true });
      }
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  },
);

const getPreOnboardingDocsByIdSlice = createSlice({
  name: "getPreOnboardingDocsById",
  initialState: {
    docs: {},
    loadingStates: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchgetPreOnboardingDocsById.pending, (state, action) => {
        const { type } = action.meta.arg;
        state.status = "loading";
        state.loadingStates[type] = true;
        state.error = null;
      })
      .addCase(fetchgetPreOnboardingDocsById.fulfilled, (state, action) => {
        const { type, url } = action.payload;
        state.status = "succeeded";
        state.docs[type] = url;
        state.loadingStates[type] = false;
      })
      .addCase(fetchgetPreOnboardingDocsById.rejected, (state, action) => {
        const { type } = action.meta.arg;
        state.status = "failed";
        state.loadingStates[type] = false;
        state.error = action.payload;
      });
  },
});

export default getPreOnboardingDocsByIdSlice.reducer;
